/**
 * Central mapping for observation forms that use structured Meds & Therapies diff UI
 * (per-field WordsDiff instead of flattening medication objects).
 */

/** Last segment of Observation.code (e.g. `forms/laborFlowSheet/postpartumHemorrhage` → `postpartumHemorrhage`). */
export function normalizeObservationFormCode(code: string | undefined): string | undefined {
  if (!code) return undefined;
  if (code.includes("/")) {
    return code.split("/").pop() || code;
  }
  return code;
}

const STRUCTURED_MED_THERAPY_FORM_NAMES = new Set<string>([
  "postpartumHemorrhage",
  "client_meds_therapies",
  "newborn_meds_therapies",
  "newborn_meds_and_therapies",
  "medsAndTherapies",
  "meds-therapies",
]);

const STRUCTURED_DIFF_WITH_MANEUVERS = new Set<string>(["postpartumHemorrhage"]);

export interface StructuredMedTherapyDiffConfig {
  usesStructuredDiff: boolean;
  includeManeuvers: boolean;
}

/**
 * Returns whether to render structured medication/therapy (and optional PPH maneuvers) diff
 * for the given normalized form name from {@link normalizeObservationFormCode}.
 */
export function getStructuredMedTherapyConfig(
  formName: string | undefined,
): StructuredMedTherapyDiffConfig {
  if (!formName) {
    return { usesStructuredDiff: false, includeManeuvers: false };
  }
  const usesStructuredDiff = STRUCTURED_MED_THERAPY_FORM_NAMES.has(formName);
  return {
    usesStructuredDiff,
    includeManeuvers: usesStructuredDiff && STRUCTURED_DIFF_WITH_MANEUVERS.has(formName),
  };
}
